var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('img',{staticClass:"warning-img",attrs:{"src":require("@/assets/views/map/icon/yes.png"),"alt":""}}),_c('span',{staticClass:"warning-text"},[_vm._v("标注信息已保存")])])
}]

export { render, staticRenderFns }